import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <App />

);
// лоадер при первой загрузке
setTimeout(() => {
  const loader = document.getElementById('loader');
  if (loader) loader.remove();
}, 300);

serviceWorkerRegistration.register({
    onUpdate: (registration) => {
      if (window.confirm('🔄 Доступна новая версия. Обновить?')) {
        registration.waiting?.postMessage({ type: 'SKIP_WAITING' });
        window.location.reload();
      }
    },
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
